var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                adChannel: false,
                adPlacement: false,
                isCountry: false,
                isDate: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel"),
                    clearable: ""
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("selectAll")))]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: {
                        label: item.serverName,
                        value: item.serverID + "+" + item.openTime
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm.paramsData.server_id.length
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("openServerDay")
                      },
                      model: {
                        value: _vm.paramsData.open_server_day,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "open_server_day", $$v)
                        },
                        expression: "paramsData.open_server_day"
                      }
                    },
                    _vm._l(_vm.dayList, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("roleId"), clearable: "" },
                model: {
                  value: _vm.paramsData.role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_id", $$v)
                  },
                  expression: "paramsData.role_id"
                }
              })
            ],
            1
          ),
          _vm.paramsData.server_id.length
            ? _c(
                "el-col",
                {
                  staticClass: "tipsClass",
                  staticStyle: { position: "relative" },
                  attrs: { span: 4 }
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: _vm.$t("customDayRange")
                    },
                    model: {
                      value: _vm.open_server_days,
                      callback: function($$v) {
                        _vm.open_server_days = $$v
                      },
                      expression: "open_server_days"
                    }
                  }),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "tipss",
                      attrs: { effect: "dark", placement: "top" }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("customDayRangeTip"))
                        },
                        slot: "content"
                      }),
                      _c("i", { staticClass: "el-icon-question " })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 8 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exportdataDealoading,
                    disabled: !this.tableData.length
                  },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "server_id", label: _vm.$t("server") }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_day", label: _vm.$t("openServerDay") }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_id", label: _vm.$t("roleId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_name", label: _vm.$t("roleName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "duration", label: _vm.$t("dailyPlayDuration") }
          }),
          _c("el-table-column", {
            attrs: { prop: "level", label: _vm.$t("roleLevel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "fighting", label: _vm.$t("roleFightPower") }
          }),
          _c("el-table-column", {
            attrs: { prop: "daily_task", label: _vm.$t("mainLevel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "total_amount", label: _vm.$t("totalRecharge") }
          }),
          _c("el-table-column", {
            attrs: { prop: "event_time", label: _vm.$t("eventTime") }
          }),
          _c("el-table-column", {
            attrs: { prop: "main_line_task", label: _vm.$t("taskProgress") }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "register_time",
              label: _vm.$t("characterRegisterTime"),
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_login_time",
              label: _vm.$t("lastLoginTime"),
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "recharge_time",
              label: _vm.$t("lastRechargeTime"),
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "160", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.goToHistory(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("historyDataList")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total
            },
            on: { "size-change": _vm.sizeChange, "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("historyList", { ref: "historyList" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }